<template>
  <v-container fluid>
    <h3>{{ $tt('customChangePasswordSuccess') }}</h3>
    <br />
    <v-btn :to="{ name: 'UserSettings' }" color="primary" class="white--text text-none">
      {{ $tt('customUserSettings') }}
    </v-btn>
  </v-container>
</template>
<script>
export default {
  name: 'user-password-success',
}
</script>
